<button
  #basicButton
  class="basic-button"
  [ngClass]="{
    'basic-button--primary': primary,
    'basic-button--secondary': secondary,
    'basic-button--lg': lg,
    'basic-button--md': md,
    'basic-button--sm': sm,
    'basic-button--loading': loading,
    'basic-button--disabled': disabled,
    'basic-button--pressed': isPressed
  }"
  [disabled]="disabled || loading"
  (click)="handleClick($event)"
  (mousedown)="handleInteraction($event)"
  (mouseup)="handleInteraction($event)"
  (keydown)="handleInteraction($event)"
  (keyup)="handleInteraction($event)"
  aria-busy="loading"
  aria-disabled="disabled"
  aria-label="basic button"
>
  <ng-container *ngIf="loading">
    <zaver-loading-dots [color]="'#b7bcc8'"></zaver-loading-dots>
  </ng-container>
  <ng-container *ngIf="!loading">
    <span
      *ngIf="iconName && !icon"
      class="basic-button__icon"
      aria-hidden="true"
    >
      <img [src]="iconName" alt="icon" size="20" />
    </span>
    <span *ngIf="icon" class="basic-button__icon" aria-hidden="true">
      {{ icon }}
    </span>
    <span class="button-text">{{ text }}</span>
  </ng-container>
</button>
